import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ShowcaseGetAllByPage } from '../../services';

export const fetchShowcaseGetAllByPage = createAsyncThunk(
    'showcaseGetAllByPage/fetchShowcaseGetAllByPage',
    async () => {
        const response = await ShowcaseGetAllByPage()
        return response.result
    }
);

const showcaseGetAllByPageSlice = createSlice({
    name: 'showcaseGetAllByPage',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowcaseGetAllByPage.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchShowcaseGetAllByPage.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchShowcaseGetAllByPage.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default showcaseGetAllByPageSlice.reducer;
